import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import { WhatsAppLogo } from "@/components/ChatAttach";
import { useLocation } from "react-router-dom";

const WA_URL = process.env.REACT_APP_WHATSAPP_URL + "?text=" + encodeURIComponent(
  "Ciao! Vorrei informazioni sulle card smart NFC + QR di InfinityFeedback."
);

export const WhatsAppButton = () => {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  if (pathname.startsWith("/studio")) return null;
  return (
    <motion.a
      href={WA_URL}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-button"
      aria-label="WhatsApp"
      title={t("common.whatsapp")}
      initial={{ scale: 0, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      transition={{ delay: 1.2, type: "spring", stiffness: 260, damping: 18 }}
      whileHover={{ scale: 1.06 }}
      className="if-float-pill fixed bottom-[50px] left-4 sm:bottom-[54px] sm:left-5 z-[55] bg-[#25D366] hover:bg-[#1EBE5B] text-white border border-white/20"
      style={{ marginBottom: "env(safe-area-inset-bottom)" }}
    >
      <WhatsAppLogo className="w-3.5 h-3.5 shrink-0" /> WhatsApp
    </motion.a>
  );
};
